module.exports = __webpack_public_path__ + "img/score-icon.d86906f8.png";